import { Component } from '@angular/core';
import { CardKpiSummaryComponent } from 'app/components/card-kpi-summary/card-kpi-summary.component';

@Component({
  selector: 'app-page-kpi-summary',
  imports: [CardKpiSummaryComponent],
  templateUrl: './page-kpi-summary.component.html',
  styleUrl: './page-kpi-summary.component.scss',
})
export class PageKpiSummaryComponent {}
